<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/Group 24.svg" alt="" />
        <div class="settings-card__header-headline">
            <h2>Bine ați venit!</h2>
            <h4>
                Proiecte
            </h4>
        </div>
    </div>
</div>
<div class="requests-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Listă Proiecte</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.add')"
                                type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
                                <i class="fa-solid fa-plus"></i>
                                Adaugă
                            </button>
                        </div>
                    </div>

                    <div class="card-container request-filter p-2" *ngIf="showCard">
                        <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
                            <br />
                            <div class="row">
                                <div class="col d-flex justify-content-center align-items-center">
                                    <mat-form-field>
                                        <mat-label>Număr Proiect</mat-label>
                                        <input matInput type="number" formControlName="id_proiect" />
                                    </mat-form-field>
                                </div>
                                <div class="col d-flex justify-content-center align-items-center">
                                    <mat-form-field>
                                        <mat-label>Tip Proiect</mat-label>
                                        <mat-select formControlName="scale">
                                            <mat-option *ngFor="let row of project_type" [value]="row.value">
                                                {{ row.key }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col d-flex justify-content-center align-items-center">
                                    <mat-form-field class="w-100" appearance="fill">
                                        <mat-label>Tag Proiect</mat-label>
                                        <input type="text" matInput formControlName="name_tag"
                                            [matAutocomplete]="auto" />
                                        <mat-icon matSuffix class="opacity-50">search</mat-icon>
                                        <mat-autocomplete #auto="matAutocomplete">
                                            <mat-option *ngFor="let tag of searchedTags" [value]="tag.name"
                                                (onSelectionChange)="onTagSelected(tag)">
                                                {{ tag.name }}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </div>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col d-flex justify-content-center align-items-center">
                                    <mat-form-field>
                                        <mat-label>Secțiune</mat-label>
                                        <mat-select formControlName="id_sectiune"
                                            (selectionChange)="onSectiuneChange($event.value)">
                                            <mat-option *ngFor="let row of sectiuni" [value]="row.id">
                                                {{ row.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col d-flex justify-content-center align-items-center">
                                    <mat-form-field>
                                        <mat-label>Categorie Proiect</mat-label>
                                        <mat-select formControlName="id_categorie">
                                            <mat-option *ngFor="
                                                let categorie of categoriiActive$ | async
                                                " [value]="categorie.id">
                                                {{ categorie.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col d-flex justify-content-center align-items-center">
                                    <mat-form-field>
                                        <mat-label>Direcție</mat-label>
                                        <mat-select formControlName="id_directie"
                                            (selectionChange)="onDirectieChange($event.value)">
                                            <mat-option *ngFor="let directie of directiiActive" [value]="directie.id">
                                                {{ directie.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col d-flex justify-content-center align-items-center">
                                    <mat-form-field>
                                        <mat-label>Compartiment</mat-label>
                                        <mat-select formControlName="id_compartiment">
                                            <mat-option *ngFor="let compartiment of compartimenteActive$ | async"
                                                [value]="compartiment.id">
                                                {{ compartiment.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col d-flex justify-content-center align-items-center">
                                    <mat-form-field>
                                        <mat-label>Responsabil Proiect</mat-label>
                                        <mat-select formControlName="id_responsible">
                                            <mat-option *ngFor="
                                                let responsabil of responsabili
                                                " [value]="responsabil.id">
                                                {{ responsabil.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col d-flex justify-content-center align-items-center">
                                    <mat-form-field>
                                        <mat-label>Operator Teren</mat-label>
                                        <mat-select formControlName="id_operator_teren">
                                            <mat-option *ngFor="
                                                let operator of operatori
                                                " [value]="operator.id">
                                                {{ operator.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <br />
                            <div class="row ">
                                <div class="col d-flex justify-content-center align-items-center">
                                    <mat-form-field>
                                        <mat-label>Tip Furnizor</mat-label>
                                        <mat-select formControlName="provider_type"
                                            (selectionChange)="onTipFurnizoriChange($event.value)">
                                            <mat-option *ngFor="let row of provider_type" [value]="row.value">
                                                {{ row.key }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col d-flex justify-content-center align-items-center">
                                    <mat-form-field>
                                        <mat-label>Furnizor</mat-label>
                                        <mat-select formControlName="id_provider">
                                            <mat-option *ngFor="
                                                let furnizor of furnizoriActive$ | async
                                                " [value]="furnizor.id">
                                                {{ furnizor.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <br />
                            <div class="row ">
                                <div class="col d-flex justify-content-start">
                                    <button (click)="toggleCard()" type="button" class="btn btn-sm btn-warning">
                                        Închide
                                    </button>
                                </div>
                                <div class="col d-flex justify-content-end">
                                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                        Resetează
                                    </button>
                                    <button type="submit" class="btn btn-sm btn-primary ms-2">
                                        Aplică
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start">
                            <button class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="Filtrare" />
                                <span>Filtre</span>
                            </button>
                            <button class="action-button" (click)="toggleArhiva()"
                                [class.active-arhiva]="selectedArhivaID">
                                <span>Arhivă</span>
                            </button>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <!-- Notifications Chip -->
                            <mat-chip-set *ngIf="notificationParameter.name" aria-label="Notification selection">
                                <mat-chip-row (click)="removeChip()">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <span class="chip-title">
                                            {{notificationParameter.name}}
                                        </span>
                                        <mat-icon style="margin-left: 3px;" aria-label="Remove">cancel</mat-icon>
                                    </div>
                                </mat-chip-row>
                            </mat-chip-set>
                            <!-- Datepicker -->
                            <button type="button" class="btn btn-light action-button" [popover]="popTemplate"
                                [adaptivePosition]="true" container="body" boundariesElement="viewport"
                                placement="left">
                                <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate | date :
                                    "dd.MM.yyyy"
                                    }}
                                </span>
                            </button>

                            <!-- Popover Template below-->
                            <ng-template #popTemplate>
                                <div class="popover">
                                    <div class="row">
                                        <div class="col d-flex justify-content-between">
                                            <h2>Selectați intervalul</h2>
                                            <button style="height: 40px; width: 100px" class="btn btn-light close-btn"
                                                (click)="closePopover()">
                                                <img src="assets/icons/close.svg" alt="Închide"
                                                    style="height: 20px; width: 20px" />
                                                <span class="close-text">ÎNCHIDE</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <h3>Filtrare după</h3>
                                            <select [(ngModel)]="dateFilterOption" (change)="onDateFilterChange()">
                                                <option *ngFor="let option of dateFilteringOptions" [value]="option.id">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-2">
                                        <div class="col d-flex justify-content-between">
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_0_days'
                                                " (click)="setLastXDays(0)">
                                                <span>AZI</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_7_days'
                                                " (click)="setLastXDays(7)">
                                                <span>7 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_30_days'
                                                " (click)="setLastXDays(30)">
                                                <span>30 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'current_year'
                                                " (click)="setYear(0)">
                                                <span>AN CURENT</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'next_year'
                                                " (click)="setYear(1)">
                                                <span>AN ANTERIOR</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="datepicker-container">
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">DE LA:</div>
                                                <div class="date">
                                                    {{ selectedStartDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #startCalendar [startAt]="selectedStartDate"
                                                    [(selected)]="selectedStartDate" [maxDate]="selectedEndDate"
                                                    (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">PANA LA:</div>
                                                <div class="date">
                                                    {{ selectedEndDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                    [maxDate]="maxDate" (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>

                    <div class="request-filter-container">
                        <div class="request-filter">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onStatusChange($event)" [value]="selectedStatusID">
                                <mat-button-toggle *ngFor="let status of statusuriFiltered" [value]="status.id">
                                    {{ status.name }}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>

                        <div class="request-filter">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onCategoryChange($event)" [value]="selectedCategoryID">
                                <mat-button-toggle *ngFor="let option of categoryToggleOptions" [value]="option.id">
                                    {{ option.value}}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>

                    <div class="table-container">
                        <table id="datatable" class="row-border hover custom-dt  w-100" datatable
                            [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"></table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>